import type { TechFormSectionEndpoint } from "./tech-form-section-data.models";

export const TECH_FORM_ENDPOINTS = {
  generalInformation: "td_General_Info",
  contacts: "td_Contacts",
  vesselDesign: "td_Vessel_Design",
  vesselDraftSummerWinter: "td_Vessel_Draft_SummerWinter",
  vesselDraft: "td_Vessel_Draft",
  antifoulingDetails: "td_Antifouling_Details",
  lastPortCalls: "td_Last_Port_Calls",
  seca: "td_Seca",
  slowSteaming: "td_Slow_Steaming",
  powerManagementIndividualFields: "td_Power_Management_IndividualFields",
  powerManagement: "td_Power_Management",
} as const satisfies Record<string, TechFormSectionEndpoint>;

export const TECH_FORM_SECTION_ENDPOINTS: Record<number, readonly TechFormSectionEndpoint[]> = {
  1: [TECH_FORM_ENDPOINTS.generalInformation, TECH_FORM_ENDPOINTS.contacts],
  2: [TECH_FORM_ENDPOINTS.vesselDesign],
  3: [TECH_FORM_ENDPOINTS.vesselDraftSummerWinter, TECH_FORM_ENDPOINTS.vesselDraft],
  4: [TECH_FORM_ENDPOINTS.antifoulingDetails],
  5: [TECH_FORM_ENDPOINTS.lastPortCalls],
  6: [TECH_FORM_ENDPOINTS.seca],
  7: [TECH_FORM_ENDPOINTS.slowSteaming],
  8: [
    TECH_FORM_ENDPOINTS.powerManagementIndividualFields,
    TECH_FORM_ENDPOINTS.powerManagement,
    TECH_FORM_ENDPOINTS.vesselDesign,
  ],
  9: [],
};
